import { render, staticRenderFns } from "./ResearchIncomeMetadataCell.vue?vue&type=template&id=4e4478ae&scoped=true&"
import script from "./ResearchIncomeMetadataCell.vue?vue&type=script&lang=js&"
export * from "./ResearchIncomeMetadataCell.vue?vue&type=script&lang=js&"
import style0 from "./ResearchIncomeMetadataCell.vue?vue&type=style&index=0&id=4e4478ae&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4478ae",
  null
  
)

export default component.exports